<template>
  <div style="padding-left: 10px;margin-top: 10px">

    <div style="margin: 10px 0 0 0;">
      <el-form label-width="150px" style="">
        <el-form-item label="订单编号" style="display: flex;align-items: center">
          <el-select v-model="purchaseReceive.order_id" placeholder="请选择订单编号" filterable clearable
                     @change="getPurchase"
                     @keyup.enter="orderSearch" class="inputReceive">
            <el-option v-for="item in orderList" :key="item.id" :label="item.order_no"
                       :value="item.id"/>
          </el-select>
          <el-button :loading="loading" @click="orderSearch" style="margin-left: 10px;">查询</el-button>
          <KfMessage ref="orderMessage"/>
        </el-form-item>

        <el-form-item>
          <el-card shadow="never" style="width: 1100px">
            <el-row>
              <el-col :span="3" class="item-text">改机客户：</el-col>
              <el-col :span="4" class="item-value">{{ order.customer_name }}</el-col>
              <el-col :span="3" class="item-text">原产品名称：</el-col>
              <el-col :span="7" class="item-value">{{ order.from_product_name }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'product'}"
                             :button="productDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.productSum }}
                <label style="color:red">（{{ order.productCnt }}）</label>
              </el-col>
              <el-col :span="3" class="item-text">目标产品名称：</el-col>
              <el-col :span="7" class="item-value">{{ order.to_product_name }}</el-col>
            </el-row>
            <el-row>

              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'memory'}"
                             :button="memoryDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.memorySum }}<label
                  style="color:red">（{{ order.memoryCnt }}）</label></el-col>
              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'disk'}"
                             :button="diskDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.diskSum }}<label
                  style="color:red">（{{ order.diskCnt }}）</label></el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'cpu'}"
                             :button="cpuDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.cpuSum }}<label
                  style="color:red">（{{ order.cpuCnt }}）</label></el-col>
              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'gpu'}"
                             :button="gpuDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.gpuSum }}<label
                  style="color:red">（{{ order.gpuCnt }}）</label></el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="item-text">
                <FrameButton :key="order.order_id"
                             :parentData="{order_id: purchaseReceive.order_id,material_type: 'network'}"
                             :button="networkDetailButton"></FrameButton>
              </el-col>
              <el-col :span="4" class="item-value">{{ order.networkSum }}<label
                  style="color:red">（{{ order.networkCnt }}）</label></el-col>
            </el-row>
          </el-card>
        </el-form-item>

        <el-form-item label="采购单号" style="display: flex;align-items: center;">
          <el-select v-model="purchaseReceive.purchase_id" placeholder="请选择采购单号" filterable clearable
                     @change="getMaterialByPurchaseId"
                     class="inputReceive">
            <el-option v-for="item in purchaseList" :key="item.id" :label="item.id"
                       :value="item.id"/>
          </el-select>
        </el-form-item>

        <el-form-item label="物料选择" style="display: flex;align-items: center;">
          <el-select v-model="purchaseReceive.material_id" placeholder="请选择物料类型" filterable clearable
                     class="inputReceive">
            <el-option v-for="item in materialList" :key="item.id" :label="item.name"
                       :value="item.id"/>
          </el-select>
        </el-form-item>

        <el-form-item label="收货检查结果">
          <el-select v-model="purchaseReceive.check_result" placeholder="请输入收货检查结果" filterable clearable
                     class="inputReceive">
            <el-option v-for="item in checkResultList" :key="item.value" :label="item.name"
                       :value="item.value"/>
          </el-select>
        </el-form-item>

        <el-form-item label="外观不良照片">
          <FrameItem v-model="purchaseReceive.image_ids" @fileChange="setImageId" :auto-upload="false" :item="image">
            <el-icon>
              <Plus/>
            </el-icon>
          </FrameItem>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="purchaseReceive.remark" type="textarea" placeholder="请输入备注"
                    class="inputReceive"></el-input>
        </el-form-item>

        <el-form-item label="SN码" style="display: flex;align-items: center;margin-top: 30px">
          <el-input v-model.trim="purchaseReceive.sn" placeholder="请扫SN码" @keyup.enter="addPurchaseReceive" clearable
                    class="inputReceive"></el-input>
          <el-button :disabled="disabled" @click="addPurchaseReceive">提交</el-button>
          <KfMessage ref="addPurchaseReceive"/>
        </el-form-item>

        <el-form-item>
          {{ "（* 扫SN后数据将会自动提交，请先输入检查结果!）" }}
        </el-form-item>
      </el-form>
    </div>
  </div>


</template>

<script>

import {Plus} from "@element-plus/icons-vue";

export default {
  name: "ItemReceive",
  computed: {
    checkResultList() {
      return this.$store.getters['core/getDictList']('rebuild_check_result');
    },
    materialTypeList() {
      return this.$store.getters['core/getDictList']('rebuild_material_type');
    },
  },
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  provide() {
    return {
      $fn: {
        orderSearch: () => {
          this.orderSearch();
        },
      }
    }
  },
  data() {
    return {
      productDetailButton: {
        "component": "button",
        "text": true,
        "label": "整机需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "整机需求详情",
          "width": 1200,
          "height": 700
        }
      },
      memoryDetailButton: {
        "component": "button",
        "text": true,
        "label": "内存需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "内存需求详情",
          "width": 1200,
          "height": 700
        }
      },
      diskDetailButton: {
        "component": "button",
        "text": true,
        "label": "硬盘需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "硬盘需求详情",
          "width": 1200,
          "height": 700
        }
      },
      cpuDetailButton: {
        "component": "button",
        "text": true,
        "label": "CPU需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "CPU需求详情",
          "width": 1200,
          "height": 700
        }
      },
      gpuDetailButton: {
        "component": "button",
        "text": true,
        "label": "显卡需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "显卡需求详情",
          "width": 1200,
          "height": 700
        }
      },
      networkDetailButton: {
        "component": "button",
        "text": true,
        "label": "网卡需求数量：",
        "style": "padding-right:0",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameQuery",
          "type": "rebuild_purchase_receive_detail",
          "title": "网卡需求详情",
          "width": 1200,
          "height": 700
        }
      },
      currentOrderId: '',
      showReceiveDetail: false,
      showSnDetail: false,
      orderList: [],
      purchaseList: [],
      materialList: [],
      loading: false,
      orderIsNull: false,
      disabled: true,
      order: {},
      sn: '',
      receiveSnCnt: 0,
      purchaseReceive: {
        sn: '',
        order_id: '',
        purchase_id: '',
        material_id: '',
        snList: [],
        check_result: '',
        image_ids: '',
        remark: '',
      },
      image: {
        component: 'image_upload',
      },
    }
  },
  mounted() {
    this.getOrder()
  },
  methods: {

    //获取订单号
    async getOrder() {
      await this.$http('rebuildReceiveService.getOrder').then(data => {
        this.orderList = data
      }, errMsg => {
        return this.$refs.orderMessage.showError(errMsg)
      })
    },

    //获取采购单号
    async getPurchase() {
      this.$refs.addPurchaseReceive.clear()
      this.purchaseReceive.sn = '';
      this.purchaseReceive.purchase_id = '';
      this.purchaseReceive.material_id = '';
      this.purchaseReceive.check_result = '';
      this.purchaseReceive.remark = '';
      this.purchaseReceive.image_ids = [];
      if (!this.purchaseReceive.order_id) {
        this.order = {};
        return this.$refs.orderMessage.showError('订单号不能为空')
      }
      let params = {order_id: this.purchaseReceive.order_id}
      this.purchaseList = await this.$http('rebuildReceiveService.getPurchase', params)
    },

    //获取物料
    async getMaterialByPurchaseId() {
      this.purchaseReceive.material_id = '';
      let params = {purchase_id: this.purchaseReceive.purchase_id}
      this.materialList = await this.$http('rebuildReceiveService.getMaterialByPurchaseId', params);
    },

    //订单查询
    async orderSearch() {
      this.$refs.orderMessage.clear()
      if (!this.purchaseReceive.order_id) {
        return this.$refs.orderMessage.showError('订单号不能为空')
      }
      this.loading = true
      this.disabled = true
      let params = {order_id: this.purchaseReceive.order_id}
      await this.$http('rebuildReceiveService.getRebuildOrder', params, false)
          .then(async data => {
            this.loading = false
            this.order = data

            if (this.order.productSum === this.order.productCnt
                && this.order.memorySum === this.order.memoryCnt
                && this.order.diskSum === this.order.diskCnt
                && this.order.cpuSum === this.order.cpuCnt
                && this.order.gpuSum === this.order.gpuCnt
                && this.order.networkSum === this.order.networkCnt) {
              return this.$refs.orderMessage.showError('该订单已经接收完成');
            }
            if (this.order.productSum !== this.order.productCnt
                || this.order.memorySum !== this.order.memoryCnt
                || this.order.diskSum !== this.order.diskCnt
                || this.order.cpuSum !== this.order.cpuCnt
                || this.order.networkSum !== this.order.networkCnt) {
              this.disabled = false
            }

          }, errMsg => {
            this.loading = false
            this.order = {};
            return this.$refs.orderMessage.showError(errMsg)
          });
    },

    //添加照片
    setImageId(ids) {
      if (ids.length > 0) {
        this.purchaseReceive.image_ids = ids;
      } else {
        this.purchaseReceive.image_ids = [];
      }
    },

    //添加订单详情
    async addPurchaseReceive() {
      this.$refs.orderMessage.clear()
      this.$refs.addPurchaseReceive.clear()
      if (!this.purchaseReceive.order_id) {
        return this.$refs.addPurchaseReceive.showError("订单编号不能为空")
      }
      if (!this.purchaseReceive.purchase_id) {
        return this.$refs.addPurchaseReceive.showError("采购单号不能为空")
      }
      if (!this.purchaseReceive.material_id) {
        return this.$refs.addPurchaseReceive.showError("物料类型不能为空")
      }
      if (!this.purchaseReceive.check_result) {
        return this.$refs.addPurchaseReceive.showError("检查结果不能为空")
      }
      if (!this.purchaseReceive.sn) {
        return this.$refs.addPurchaseReceive.showError("SN不能为空")
      }

      this.purchaseReceive.from_product_id = this.order.from_product_id
      await this.$http('rebuildReceiveService.addPurchaseReceive', this.purchaseReceive, false)
          .then(async data => {
            this.purchaseReceive.sn = '';
            this.purchaseReceive.remark = '';
            this.purchaseReceive.image_ids = [];
            this.disabled = true
            this.$refs.addPurchaseReceive.showSuccess("提交成功")
            await this.orderSearch();
          }, errMsg => {
            this.$refs.addPurchaseReceive.showError(errMsg)
          });
    },

  }
}
</script>

<style scoped>
.inputReceive {
  height: 35px;
  width: 400px;
  margin-right: 10px;
}

:deep(.el-card__body) {
  padding: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  display: flex;
  align-items: center;
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

:deep(.el-button.is-text ) {
  color: #00afff;
  background-color: white;
  border: 0 solid white;
}

/*:deep(.el-descriptions__label.el-descriptions__cell.is-bordered-label){*/
/*  color: white;*/
/*  background:#4b92e4*/
/*}*/

</style>